import React from 'react';
import { Plus } from 'lucide-react';

const FloatingActionButton = ({ 
  onClick, 
  icon: Icon = Plus, 
  label = 'Add',
  disabled = false,
  testId = 'fab-button'
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`fixed bottom-24 right-4 z-40 flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-all duration-200 ${
        disabled
          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
          : 'bg-sage text-white hover:bg-sage-dark hover:scale-105 active:scale-95'
      }`}
      data-testid={testId}
      aria-label={label}
    >
      <Icon size={24} />
    </button>
  );
};

export default FloatingActionButton;
